import React from "react";
import { hasPermission, hasAnyPermission, hasAllPermissions, isSuperAdmin } from "../../utils/permissions";

/**
 * Composant pour afficher conditionnellement du contenu selon les permissions
 * 
 * @param {string|Array<string>} permission - Permission(s) requise(s)
 * @param {string} mode - 'any' (au moins une) ou 'all' (toutes) - par défaut 'any'
 * @param {React.ReactNode} children - Contenu à afficher si la permission est accordée
 * @param {React.ReactNode} fallback - Contenu à afficher si la permission n'est pas accordée (optionnel)
 */
const PermissionGate = ({ permission, mode = "any", children, fallback = null }) => {
  // Le superadmin a accès à tout
  if (isSuperAdmin()) {
    return <>{children}</>;
  }
  
  if (!permission) {
    // Si pas de permission requise, afficher le contenu
    return <>{children}</>;
  }

  let hasAccess = false;

  if (Array.isArray(permission)) {
    // Si c'est un tableau de permissions
    hasAccess = mode === "all" 
      ? hasAllPermissions(permission)
      : hasAnyPermission(permission);
  } else {
    // Si c'est une seule permission
    hasAccess = hasPermission(permission);
  }

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default PermissionGate;

